@if (label) {
  <div class="uppercase text-size_xs font-semibold relative top-1 text-navy-600">{{ label }}</div>
}
<div
  (fileDropped)="onFileDropped($event)"
  [ngClass]="{ 'p-disabled': disableUpload }"
  appUploadDrop
  class="border border-navy-300 border-solid p-3 mt-1.5 upload-drop-area"
>
  <span (click)="onOpenWindow()" class="text-blue-700 flex items-center gap-2.5 pointer-cursor">
    <span class="icon-upload flex items-center"></span>
    <span class="italic text-blue-700 font-bold text-size_l">{{ placeholder }}</span>
  </span>
  @for (file of files; track file; let index = $index) {
    @if (file && !file.toBeDeleted) {
      <span (click)="onOpenWindow()" class="flex items-center gap-5 pointer-cursor">
        <span class="text-blue-700 my-1.5 flex-1">
          {{ file.name | shortenFileName }}
        </span>
        <span
          (click)="onRemoveFile(file, index); $event.stopPropagation()"
          [ngClass]="{ 'p-disabled': disableUpload, hidden: hideRemoveFileIcon }"
          class="icon-remove-circle-x text-blue-700 hover:text-red-500"
        ></span>
      </span>
    }
  }
</div>
